var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutlinedFlag24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 3.50066L14.4998 5.50074L20.4998 5.50123L20.499 15.5012L13.499 15.5007L12.4992 13.5006L7.49918 13.5002L7.49861 20.5002L5.49861 20.5L5.5 3.5L13.5 3.50066ZM14.4992 13.5007L18.4992 13.5011L18.4997 7.50107L13.4997 7.50066L12.4998 5.50057L7.49984 5.50016L7.49934 11.5002L13.4993 11.5007L14.4992 13.5007Z",
    fill: "#505255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlinedFlag24Px);
export default __webpack_public_path__ + "static/media/outlined_flag_24px.f57a036989b0a7a97c72d7ea08fb56d1.svg";
export { ForwardRef as ReactComponent };